// extracted by mini-css-extract-plugin
module.exports = {"badge":"MashControlBadge_badge__1SRyk"};